import { z } from "zod/v4";

export const PutMeterLogRequestBodySchema = z.object({
  subscriptionLinkId: z.string(),
});

export type PutMeterLogRequestBodyType = z.infer<
  typeof PutMeterLogRequestBodySchema
>;

export const PutMeterLogResponseBodySchema = z.string();

export type PutMeterLogResponseBodyType = z.infer<
  typeof PutMeterLogResponseBodySchema
>;
